import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../core/services/client/client.service';
import { Subscription } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ActivationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-select-policy-year',
    templateUrl: './select-policy-year.component.html',
    styleUrls: ['./select-policy-year.component.scss'],
    standalone: false
})
export class SelectPolicyYearComponent implements OnInit {

  public Years: Array<any> = [];
  public selectedClient;

  selectedClientSubscription: Subscription;

  selectYearFormGroup = new UntypedFormGroup({
    year: new UntypedFormControl()
  });
  clientListSubscription: Subscription;
  show = false;
  currentRoutePath: string;

  constructor(
    private clientService: ClientService,
    private router: Router,
    private loaderService: LoaderService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        this.currentRoutePath = `/${event.snapshot.routeConfig.path}`;
      }
    });
    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      this.show = (client && client.checked) ? true : false;
      if (client && client.checked) {
        this.getPolicyYears(client.Number);
        this.selectedClient = client;
      }
    });
    this.clientListSubscription = this.clientService.clientList.subscribe(clients => {
      this.show = (this.selectedClient && clients) && clients.filter(cl => cl.Id === this.selectedClient.Id).length > 0;
    });
  }

  ngOnDestroy() {
    this.selectedClientSubscription.unsubscribe();
  }
  isWaiverManagement() {
    return location.pathname.indexOf('waiver-management') > -1;
  }
  ngOnInit() { }

  setSelectedYear() {
    this.router.navigateByUrl(this.currentRoutePath);
    this.setYearValue(this.selectYearFormGroup.controls['year'].value);
  }

  setYearValue(year) {
    this.selectedClient.PolicyYear = Number(year);
    this.clientService.setSelectedClient(this.selectedClient);
  }

  setDefaultValue() {
    let selectedPolicyYear = null;
    if (this.Years) {
      selectedPolicyYear = this.Years[0]?.id;
    }
    if (selectedPolicyYear) {
      this.selectYearFormGroup.controls['year'].setValue(selectedPolicyYear);
      console.log(selectedPolicyYear);
      this.setYearValue(selectedPolicyYear);
    }
  }

  getPolicyYears(clientNumber: number) {
    console.log(clientNumber);
    if (this.selectedClient && this.selectedClient.Number === clientNumber && this.Years.length > 0) {
      return;
    }
    this.clientService.getPolicyYears(clientNumber).subscribe(years => {
      if (years === '{}' || Object.keys(years).length === 0) {
        years = [];
      } else {
        console.log(years);
        years = years['PolicyYear'].split('|');
      }
      this.Years = [];

      years.forEach(element => {
        this.Years.push({ id: Number(element), value: element + '-' + (++element) });
      });
      this.clientService.setMaxPolicyYear(this.Years[this.Years?.length - 1]?.id);
      if (this.Years.length < 2) {
        this.selectYearFormGroup.disable();
      } else {
        this.selectYearFormGroup.enable();
      }
      this.setDefaultValue();
      this.loaderService.handlePolicySpinner(false);
    });
  }
}
